import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Home, Cake, Heart, MessageCircle } from "lucide-react";
import { useFavorites } from "../hooks/useFavorites";
import { useCart } from "../hooks/useCart";
import { BrandOrderMark } from "./BrandOrderMark";

export const PublicBottomNav = ({ whatsapp }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { favs } = useFavorites();
  const { count } = useCart();

  const items = [
    { icon: Home, label: "Inicio", tid: "inicio", to: "/" },
    { icon: Cake, label: "Catálogo", tid: "catalogo", to: "/catalogo" },
    { label: "Carrito", tid: "carrito", to: "/carrito", center: true },
    { icon: Heart, label: "Favoritos", tid: "favoritos", to: "/favoritos", badge: favs.length },
    { icon: MessageCircle, label: "WhatsApp", tid: "whatsapp", wa: true },
  ];

  const go = (it) => {
    if (it.wa) { window.open(`https://wa.me/${(whatsapp || "").replace(/\D/g, "")}?text=${encodeURIComponent("Hola Kelifa 🌸")}`, "_blank"); return; }
    navigate(it.to);
  };

  return (
    <nav className="lg:hidden fixed bottom-4 left-1/2 -translate-x-1/2 w-[92%] max-w-md z-50" data-testid="public-bottom-nav">
      <div className="bg-[#4B1025]/95 backdrop-blur-xl border border-crema/10 rounded-[30px] px-3 py-3 grid grid-cols-5 items-center shadow-[0_20px_40px_rgba(75,16,37,0.35)]">
        {items.map((it) => {
          const active = !it.wa && (it.to === "/" ? pathname === "/" : pathname.startsWith(it.to));
          if (it.center) {
            return (
              <button key={it.label} onClick={() => go(it)} data-testid={`bnav-${it.tid}`}
                aria-label="Hacer pedido"
                className="relative mx-auto -mt-9 w-[72px] h-[72px] flex items-center justify-center -translate-x-1 active:scale-95 transition-transform">
                <BrandOrderMark />
                {count > 0 && <span className="absolute top-0 right-1 bg-crema text-vinoDark border-2 border-vinoDark text-[10px] font-bold min-w-5 h-5 px-1 rounded-full flex items-center justify-center">{count}</span>}
                <span className="sr-only">Carrito</span>
              </button>
            );
          }
          return (
            <button key={it.label} onClick={() => go(it)} data-testid={`bnav-${it.tid}`}
              className={`relative w-full min-w-0 flex flex-col items-center justify-center gap-0.5 text-[10px] transition-colors ${active ? "text-rosa" : "text-crema/50"}`}>
              <it.icon className="w-5 h-5" />
              {it.label}
              {it.badge > 0 && <span className="absolute -top-1 right-1 bg-rosa text-vinoDark text-[9px] font-bold w-4 h-4 rounded-full flex items-center justify-center">{it.badge}</span>}
            </button>
          );
        })}
      </div>
    </nav>
  );
};
